import React, { useState } from "react";
import { generateClient } from "aws-amplify/api";
import { Box, Button } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import InputText from "../../components/InputText";
import Selector from "../../components/Selector";
import { useSelector } from "react-redux";
import { updateUserAttributes } from "aws-amplify/auth";
import { toast } from "react-toastify";

const client = generateClient();

const validationSchema = yup.object({
	fullName: yup.string().required("Full Name is required"),
	companyName: yup.string().required("Company Name is required"),
	email: yup
		.string()
		.required("Official Email Address is required")
		.email("Enter a valid email"),
	designation: yup.string().required("Designation is required"),
});

export default function ProfileCreateForm(props) {
	const token = JSON.parse(localStorage.getItem("token") || "{}");
	const user = useSelector((state) => state.auth.user);
	const [userData, setUserData] = useState({});
	const [isLoading, setLoading] = useState(false);
	console.log(userData, "userData");

	const formik = useFormik({
		initialValues: {
			fullName: user?.attributes?.["custom:name"] || "",
			companyName: user?.attributes?.["custom:companyName"] || "",
			email: user?.attributes?.email || "",
			designation: user?.attributes?.["custom:designation"] || "",
			language: "english",
		},
		validationSchema: validationSchema,
		onSubmit: async (values) => {
			setLoading(true);
			try {
				const attributes = {
					"custom:name": values.fullName,
					"custom:companyName": values.companyName,
					email: values.email,
					"custom:designation": values.designation,
				};
				await updateUserAttributes({
					userAttributes: attributes,
				});
				setLoading(false);
				toast.success("Profile updated successfully");
			} catch (error) {
				console.log(error?.message);
				setLoading(false);
				toast.error("Failed to update profile");
			}
		},
	});

	console.log("ProfileCreateForm", formik.values);

	return (
		<Box sx={{ width: "100%" }}>
			<form onSubmit={formik.handleSubmit}>
				<Box width={"100%"} display={"flex"} gap={10}>
					<Box width={"100%"}>
						<InputText
							formik={formik}
							label={"Full Name"}
							id={"fullName"}
							name={"fullName"}
							value={formik.values.fullName}
							type={"text"}
						/>
						<InputText
							formik={formik}
							label={"Company Name"}
							id={"companyName"}
							name={"companyName"}
							value={formik.values.companyName}
						/>
						<InputText
							formik={formik}
							label={"Designation"}
							id={"designation"}
							name={"designation"}
							value={formik.values.designation}
						/>
					</Box>
					<Box width={"100%"}>
						<InputText
							formik={formik}
							label={"Email Address"}
							id={"email"}
							name={"email"}
							value={formik.values.email}
						/>
						<Selector
							label={"Language"}
							noneValue={"Select Language"}
							formik={formik}
							name={"language"}
							options={[{ label: "English", value: "english" }]}
						/>
					</Box>
				</Box>
				<Button
					sx={{ my: 2, textTransform: "capitalize" }}
					variant="contained"
					type="submit"
					disabled={isLoading}
				>
					{isLoading ? "Saving..." : "Save Changes"}
				</Button>
			</form>
		</Box>
	);
}
